/**
 * indicates if SharedWorker is supported, in the global scope
 */
export const SharedWorkerSupported = "SharedWorker" in globalThis;